import { Dialog as BaseDialog } from '@base-ui/react/dialog';

import { cn } from '@/lib/cn';

import type { DialogSize } from './types';

const sizeMap: Record<DialogSize, string> = {
  s: 'w-[480px] max-h-[1000px]',
  m: 'w-[680px] max-h-[1000px]',
  l: 'w-[1080px] max-h-[1000px]',
  xl: 'w-[1200px] max-w-[calc(100vw-32px)] h-[calc(100vh-80px)] max-h-[1000px]',
};

type Props = {
  children: React.ReactNode;
  size?: DialogSize;
  className?: string;
};

const DialogContent = ({ children, size = 'm', className }: Props) => {
  return (
    <BaseDialog.Portal>
      <BaseDialog.Backdrop
        className={cn(
          'fixed inset-0 bg-foreground/20 backdrop-blur-[10px]',
          'transition-opacity duration-200',
          'data-[starting-style]:opacity-0 data-[ending-style]:opacity-0',
        )}
      />
      <BaseDialog.Popup
        className={cn(
          'fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
          'flex flex-col',
          'rounded-2xl border border-border bg-white',
          'shadow-[0px_2px_16px_rgba(0,0,0,0.08)]',
          'transition-all duration-200',
          'data-[starting-style]:scale-95 data-[starting-style]:opacity-0',
          'data-[ending-style]:scale-95 data-[ending-style]:opacity-0',
          'focus-visible:outline-none',
          sizeMap[size],
          className,
        )}
      >
        {children}
      </BaseDialog.Popup>
    </BaseDialog.Portal>
  );
};

export default DialogContent;
